module.exports = __webpack_public_path__ + "img/two-round.c295d29f.svg";